import { render, staticRenderFns } from "./regionOption.vue?vue&type=template&id=2064c97a&"
import script from "./regionOption.vue?vue&type=script&lang=js&"
export * from "./regionOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports